<script lang="ts">
  import type {PriceForOfcPricingItem} from "../../../types/CinemaProductsDto.types.ts";

  type OfcPriceComponentProps = {
    variationId: string;
    priceForOfcPricingItem: PriceForOfcPricingItem;
  };

  let {variationId, priceForOfcPricingItem}: OfcPriceComponentProps = $props();
</script>

<ofc-pricing-item-v1
  retail-price={priceForOfcPricingItem?.retailPrice}
  old-price={priceForOfcPricingItem?.sale ? priceForOfcPricingItem.comparativePrice : undefined}
  suggested-retail-price={priceForOfcPricingItem?.sale ? priceForOfcPricingItem.suggestedRetailPrice : undefined}
  unit-price={priceForOfcPricingItem?.normPriceValue}
  unit-price-amount={priceForOfcPricingItem?.normPriceAmount}
  unit-price-unit={priceForOfcPricingItem?.normPriceUnit}
  is-starting-price={priceForOfcPricingItem?.isStartingPrice || undefined}
  deal-highlight={priceForOfcPricingItem?.dealHighlight}
  deal-id={priceForOfcPricingItem?.dealId}
  meta-origin-feature="recoSpa"
  meta-team="hopper"
>
  <ft9-benefit-tag-v1
    slot="benefit-tag"
    id={variationId}
    feature="recoSpa"
    team="hopper"
    variation-id={variationId}
    remove-expired
    load-on-visibility
  >
  </ft9-benefit-tag-v1>
</ofc-pricing-item-v1>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  ofc-pricing-item-v1 {
    display: inline-flex;
    flex-direction: column;
  }
</style>
